
export const ModalRouteMixin = {
  data: () => ({
    open: true
  }),
  watch: {
    open(opened) {
      if (!opened) {
        this.back();
      }
    }
  },
  methods: {
    close() {
      this.open = false
    },
    back() {
      const { params, matched } = this.$route;
      const { parent } = matched.pop();

      this.$router.push({ name: parent.name, params });
    },
  }
};
